<template>
  <div id="profile">
    <div class="wrapper">
      <section class="section main-section">
        <card-component icon="cog" title="Edit Preferences">
          <preferences-form />
        </card-component>
        <card-component icon="account-cog" title="Edit Profile">
          <form @submit.prevent="submitProfile">
            <b-field message="*.png, *.jpg" label="Avatar" horizontal>
              <file-picker v-model="profileForm.avatar" is-image />
              <div class="avatar">
                <user-avatar :avatar="user.avatar" />
              </div>
            </b-field>
            <hr />
            <b-field horizontal>
              <b-button
                :loading="profileForm.isLoading"
                type="is-primary"
                native-type="submit"
              >
                Submit
              </b-button>
            </b-field>
          </form>
        </card-component>
      </section>
      <section class="section">
        <card-component title="Profile" icon="account">
          <div class="columns">
            <div class="column">
              <b-field label="Role" expanded>
                {{ user.role_name }}
              </b-field>
            </div>
          </div>
          <hr />
          <div class="columns">
            <div class="column">
              <b-field label="Email" expanded>
                {{ user.email }}
              </b-field>
            </div>
            <div class="column">
              <b-field label="Name" expanded>
                {{ user.username }}
              </b-field>
            </div>
          </div>
          <hr />
          <b-field label="Last Login">
            {{ formatDate(user.last_login) }}
          </b-field>
        </card-component>
      </section>
      <section class="section pt-0">
        <card-component title="Change Password" icon="lock">
          <change-password-form :user-id="user.id" />
        </card-component>
      </section>
    </div>
  </div>
</template>

<script>
import { read as readUser, update as updateUser } from '@/api/user'

import FilePicker from '@/components/form/FilePicker'
import ChangePasswordForm from '@/components/form/ChangePassword'
import PreferencesForm from '@/components/form/Preferences'
import UserAvatar from '@/components/base/UserAvatar'

import dayjs from '@/utils/date'

import { mapMutations } from 'vuex'

export default {
  name: 'Profile',
  components: {
    PreferencesForm,
    ChangePasswordForm,
    FilePicker,
    UserAvatar
  },
  data() {
    return {
      profileForm: {
        isLoading: false,
        avatar: null
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    }
  },
  methods: {
    ...mapMutations({
      setPreferences: 'auth/setPreferences',
      setUser: 'auth/setUser'
    }),
    formatDate(date) {
      return dayjs(date, 'YYYY-MM-DDTHH:mm:ss').format('DD MMMM YYYY HH:mm:ss')
    },
    submitProfile() {
      this.profileForm.isLoading = true

      const data = new FormData()
      data.append('id', this.user.id)
      data.append('avatar', this.profileForm.avatar)

      updateUser(data)
        .then(() => {
          this.profileForm = {
            avatar: null
          }
          readUser(this.user.id)
            .then(() => {
              // this.setUser(res.data)
              this.$buefy.toast.open({
                message: 'Profile updated',
                type: 'is-success',
                queue: false
              })
            })
        })
        .catch(e => {
          this.$buefy.toast.open({
            message: e.response.data,
            type: 'is-danger',
            queue: false
          })
        })
        .finally(() => { this.profileForm.isLoading = false })
    }
  }
}
</script>

<style lang="scss">
.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.avatar {
  display: flex;
  justify-content: center;

  .is-user-avatar {
    width: 100px;
  }
}
.main-section {
  display: flex;
  padding-bottom: 0;

  .card {
    flex: 1;

    &:first-child {
      margin-right: 0.5rem;
      margin-bottom: 0;
    }
  }
}
</style>
